import { useTranslation } from 'react-i18next';
import { FunctionaryInfo } from '../../../../shared/VolunteerApplicationServiceTypes';
import { Button, Typography } from 'antd';
import { useCallback } from 'react';
const { Text } = Typography;

interface ProposerReassignCardProps extends FunctionaryInfo {
	onSubmitClick: (functionaryId: number) => void;
}

export const ProposerReassignCard = (props: ProposerReassignCardProps) => {
	const {
		printName,
		gender,
		srcmId,
		id,
		applicationCount,
		interviewCount,
		onSubmitClick,
	} = props;
	const { t } = useTranslation();

	const handleReassignProposerClick = useCallback(() => {
		onSubmitClick(id as number);
	}, [id, onSubmitClick]);

	return (
		<>
			<div className="flex flex-col rounded-lg border border-solid border-gray-300 bg-card-bg p-[16px] py-[24px]">
				<div className="flex flex-row gap-6 mb-4">
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('fullName')}</Text>
						<Text className="text-gray-650 text-sm font-bold">{printName}</Text>
					</div>
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('gender')}</Text>
						<Text className="text-gray-650 text-sm font-bold">
							{gender &&
								gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase()}
						</Text>
					</div>
				</div>

				<div className="flex flex-row gap-6 mb-4">
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('SRCMID')}</Text>
						<Text className="text-gray-650 text-sm font-bold">{srcmId}</Text>
					</div>

					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">
							{t('currentlyAssigned')}
						</Text>
						<Text className="text-gray-650 text-sm font-bold">
							{applicationCount ?? 0}
						</Text>
					</div>
				</div>

				<div className="flex flex-row gap-6 mb-4">
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">
							{t('interviewCompleted')}
						</Text>
						<Text className="text-gray-650 text-sm font-bold">
							{interviewCount ?? 0}
						</Text>
					</div>
				</div>

				<div className="flex justify-center">
					<Button
						className={`font-sans font-bold text-sm border border-solid mt-0.5 text-primary-blue border-primary-blue w-full bg-transparent`}
						variant="outlined"
						onClick={handleReassignProposerClick}
					>
						{t('reAssign')}
					</Button>
				</div>
			</div>
		</>
	);
};
